import { render } from "./trend-chart.vue?vue&type=template&id=78002cb8"
import script from "./trend-chart.vue?vue&type=script&lang=ts"
export * from "./trend-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script